import { createGlobalStyle } from "styled-components"

const GlobalStyles = createGlobalStyle`
  :root {
    --background: #0D0C1D;
    --primary-text: #FFFFFF;
    --secondary-text: #B0B0B0;
    --accent-blue: #4F8DFB;
    --border: #3B3B58;
    --highlight: #6C9CFF;
    --input-bg: #1E1D3A;
    --error: #FF5757;
    --success: #4CAF50;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Inter', sans-serif;
    background-color: var(--background);
    color: var(--primary-text);
    min-height: 100vh;
    overflow-x: hidden;
  }

  a {
    color: var(--accent-blue);
    text-decoration: none;
    transition: color 0.3s ease;
    
    &:hover {
      color: var(--highlight);
    }
  }

  button {
    cursor: pointer;
    font-family: 'Inter', sans-serif;
  }

  input, textarea {
    font-family: 'Inter', sans-serif;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  /* Custom scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: var(--background);
  }

  ::-webkit-scrollbar-thumb {
    background: var(--border);
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: var(--accent-blue);
  }

  /* Toast customization */
  .Toastify__toast {
    background-color: var(--input-bg);
    color: var(--primary-text);
    border: 1px solid var(--border);
  }

  .Toastify__toast--error {
    border-left: 4px solid var(--error);
  }

  .Toastify__toast--success {
    border-left: 4px solid var(--success);
  }
`

export default GlobalStyles